import React, { useState } from "react";
import { Navbar, Nav, Container, Modal, Button } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import img1 from "../assets/images/logo colegio (32).png";
import config from "../assets/images/config.png";

function NavigationBar() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleLogoutConfirm = () => {
    setShowModal(false);
    // Limpieza de sesión si es necesario
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <Navbar expand="md" bg="dark" variant="dark" sticky="top" className="shadow-sm px-3">
        <Container fluid>
          <Navbar.Brand href="/portal/">
            <img src={img1} alt="logo" style={{ width: 40 }} />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />

          <Navbar.Collapse id="main-navbar" className="justify-content-end">
            <Nav>
              <Nav.Link as={NavLink} to="/inicio" className="d-flex align-items-center">
                <i className="bi bi-house-door"></i>
                <span className="ms-2 text-inicio-menu">Inicio</span>
              </Nav.Link>

              <Nav.Link as={NavLink} to="/facturas" className="d-flex align-items-center">
                <i className="bi bi-file-earmark-text"></i>
                <span className="ms-2 text-inicio-menu">Facturas</span>
              </Nav.Link>
              <Nav.Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true);
                }}
                className="d-flex align-items-center text-danger"
              >
                <i className="bi bi-box-arrow-left"></i>
                <span className="ms-2 text-inicio-menu text-danger">Salir</span>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/configuracion" className="d-flex align-items-center">
                <i className="bi bi-file-earmark-text"></i>
                <img src={config} alt="" className="ms-2" style={{ height: "30px" }} />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Modal de Confirmación */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>¿Confirmar salida?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que querés salir de tu sesión? Se cerrará tu acceso actual.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleLogoutConfirm}>
            Sí, salir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NavigationBar;
